module.exports = __webpack_public_path__ + "img/cover_smartphone2.14e17f2c.png";